import type { ReactNode } from "react"
import { AccountSidebar } from "./account-sidebar"

interface AccountLayoutUser {
  name?: string
  email?: string
}

interface AccountLayoutProps {
  children: ReactNode
  user: AccountLayoutUser | null
}

export function AccountLayout({ children, user }: AccountLayoutProps) {
  return (
    <section className='w-full px-4 md:px-0'>
      <div className='grid gap-6 lg:grid-cols-[280px_minmax(0,1fr)] lg:items-start'>
        <AccountSidebar user={user} />
        <div className='min-w-0'>{children}</div>
      </div>
    </section>
  )
}
